/* global gsap, ScrollTrigger, SplitType -- layout/theme.liquid で CDN から読み込むライブラリ */
document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll('.c_title__wrapper').forEach((wrap) => {
    const subText = wrap.querySelector('.c_title-sub .js-animation__text');
    const titleEl = wrap.querySelector('.c_title.js-animation__text');
    const icon = wrap.querySelector('.c_title-sub__icon.js-icon-up');

    const splitTargets = [];
    if (subText) splitTargets.push(subText);
    if (titleEl) splitTargets.push(titleEl);
    if (splitTargets.length) {
      new SplitType(splitTargets, { types: 'lines, words, chars' });
    }

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: wrap,
        start: 'top 70%',
        once: true,
      },
    });

    if (icon) {
      tl.to(icon, { '--c_position-y': 0, duration: 0.4, ease: 'power2.out' }, 0);
    }

    const chars = [
      ...(subText ? subText.querySelectorAll('.char') : []),
      ...(titleEl ? titleEl.querySelectorAll('.char') : []),
    ];

    if (chars.length) {
      tl.to(chars, { y: 0, duration: 0.6, stagger: 0.03, ease: 'power2.out' }, 0);
    }
  });
});
